import { render, staticRenderFns } from "./AppV3LabelsItem.vue?vue&type=template&id=090efa68&scoped=true"
import script from "./AppV3LabelsItem.vue?vue&type=script&lang=js"
export * from "./AppV3LabelsItem.vue?vue&type=script&lang=js"
import style0 from "./AppV3LabelsItem.vue?vue&type=style&index=0&id=090efa68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090efa68",
  null
  
)

export default component.exports